import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UpdateUser } from "../api/api";
import { FaCheck } from "react-icons/fa";
import "../GenderPage/GenderPage.css";
import bgImage from "../../assets/images/brown-background.jpg";
import Swal from "sweetalert2";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";

const GenderPage = () => {
  const navigate = useNavigate();
  const [selectedGender, setSelectedGender] = useState(null);
  const [showError, setShowError] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const AllGender = [
    { id: "woman", label: "Woman" },
    { id: "man", label: "Man" },
  ];

  const handleSelectGender = (id) => {
    setSelectedGender(id);
    setShowError(false);
  };

  const handleContinue = async () => {
    setIsLoading(true);
    try {
      const userDatas = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userDatas);
      const _id = parsedUserData?.id || parsedUserData?._id;

      const values = {
        user_id: _id,
        gender: selectedGender === "man" ? "M" : "F",
        profile_completion_status: "UploadImage",
      };

      const response = await UpdateUser(values);
      console.log("response_GenderPage", response);
      setUserData(JSON.stringify(response));

      if (response?.success === true) {
        navigate("/UploadImage");
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
      });
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (userData) {
      console.log("Updated userData:", userData);
    }
  }, [userData]);

  return (
    <div
      className="GenderPagecontainer sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="gndrmain">
          <div className="genderheader">
            <h2>Please Choose a Gender</h2>
          </div>

          <div className="genderpage-selection">
            {AllGender.map((gender) => (
              <button
                key={gender.id}
                className={`genderpage-option ${selectedGender === gender.id ? "selected" : ""
                  }`}
                onClick={() => handleSelectGender(gender.id)}
              >
                <span>{gender.label}</span>
                {selectedGender === gender.id && <FaCheck className="check-icon" />}
              </button>
            ))}
            {showError && <p className="error-text">Please select a Gender</p>}
          </div>

          <button
            className="continue-btn"
            onClick={handleContinue}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GenderPage;
